import { normalizeProject } from "./projectDirectory";
import { projectUpdatesApi } from "../projectUpdatesApi";

export const statusColors = { Ongoing: "#ffbf3f", Completed: "#49ca94", "On Hold": "#ff616b", Planning: "#6d9ff6", Cancelled: "#a894cd", Unknown: "#9da9ba" };
export const dashboardStatus = (status) => status === "Ongoing" ? "In Progress" : status;
export const projectTime = (project) => project.updatedAt || project.updated_at || project.createdAt || project.created_at;
export const updateTime = (update) => update.createdAt || update.created_at || update.updateDate || update.update_date;
export const newestFirst = (getDate) => (a, b) => (Date.parse(getDate(b)) || 0) - (Date.parse(getDate(a)) || 0);

export function readDashboardList(data, key) {
  const list = Array.isArray(data) ? data : data?.[key] ?? data?.data;
  if (!Array.isArray(list)) throw new Error(`The server returned an invalid ${key} list.`);
  return list;
}

export function dashboardProject(raw) {
  return { ...normalizeProject(raw), status: raw.status ? normalizeProject(raw).status : "Unknown" };
}

export function countClientProjects(client, projects) {
  if (!projects || projects.some((project) => project.clientId === undefined && project.client === undefined && !project.clientEmail)) return null;
  let count = 0;
  for (const project of projects) {
    const id = project.clientId ?? project.client?.id ?? project.client?.userId;
    const email = project.clientEmail || project.client?.email;
    if (id != null) { if (client.id != null && String(id) === String(client.id)) count += 1; }
    else if (email) { if (client.email && email.toLowerCase() === client.email.toLowerCase()) count += 1; }
    else if (project.client != null && project.clientId !== null) return null;
  }
  return count;
}

// Limit concurrent requests while using the existing per-project update endpoint.
export async function collectDashboardUpdates(projects, isActive = () => true) {
  const updates = [];
  let failed = 0;
  for (let start = 0; start < projects.length && isActive(); start += 4) {
    const batch = await Promise.allSettled(projects.slice(start, start + 4).map(async (project) => {
      const list = await projectUpdatesApi.list(project.id);
      return list.map((update, index) => ({ ...update, project, key: `${project.id}-${update.id ?? index}` }));
    }));
    for (const result of batch) {
      if (result.status === "fulfilled") updates.push(...result.value);
      else failed += 1;
    }
  }
  return { updates: updates.sort(newestFirst(updateTime)), failed };
}

export function relativeDate(value, now = new Date()) {
  const time = Date.parse(value);
  if (!Number.isFinite(time)) return "Date unavailable";
  const days = Math.floor((now.getTime() - time) / 86400000);
  if (days < 0) return new Intl.DateTimeFormat("en-IN", { day: "numeric", month: "short", timeZone: "Asia/Kolkata" }).format(time);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return `${days} days ago`;
  if (days < 30) return `${Math.floor(days / 7)} ${days < 14 ? "week" : "weeks"} ago`;
  return new Intl.DateTimeFormat("en-IN", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Kolkata" }).format(time);
}
